export default "__VITE_ASSET__CVuKkh4n__"